import { CATEGORY_ROUTE_PREFIX } from '~/constants';

const getPromosLinkFromSlug = (slug: string) => {
  return `/${CATEGORY_ROUTE_PREFIX}/${slug}`;
};

export default getPromosLinkFromSlug;
